/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { PinOutcomeMetadataResponse, PinOutcomeMetadataVars } from '../openapi-types.gen.js';

export type { PinOutcomeMetadataResponse, PinOutcomeMetadataVars } from '../openapi-types.gen.js';

export const usePinOutcomeMetadata = createMutationHook<PinOutcomeMetadataVars, PinOutcomeMetadataResponse, unknown>({
  specName: 'usePinOutcomeMetadata',
  path: '/v1/outcome-suggestions/{id}/metadata-uri',
  method: 'POST',
  resolveUrl: (vars: PinOutcomeMetadataVars) => `/v1/outcome-suggestions/${vars.id}/metadata-uri`,
  buildBody: (vars: PinOutcomeMetadataVars) => ({ outcomeMintPubkey: vars.outcomeMintPubkey, outcomeIndex: vars.outcomeIndex }),
  parseResponse: (raw: unknown): PinOutcomeMetadataResponse => raw as PinOutcomeMetadataResponse,
  
  
  
});
